<template>
      <div></div>
</template>

<script>

    export default {

        data: function() {
            return  {
                formcompleted: false,
                formdata:{
                    'start' :
                    {
                        title: this.trans.application.titel_start_datum[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'startdate',
                                name: 'Start Datum',
                                value: '',
                                label: '',
                                type: 'datemonth',
                                mode: 'next',
                                validation: ['required'],
                                placeholder: false,
                            }
                        ]
                    },
                    'your':
                    {
                        title: this.trans.application.titel_ihre_angaben[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'your-name',
                                name: 'Name',
                                value: '',
                                label: this.trans.application.name[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'your-firstname',
                                name: 'Vorname',
                                value: '',
                                label: this.trans.application.vorname[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'your-email',
                                name: 'E-Mail',
                                value: '',
                                label: this.trans.application.mail[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'your-phone',
                                name: 'Telefon',
                                value: '',
                                label: this.trans.application.telefon[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            }
                        ]
                    },
                    'child':
                    {
                        title: this.trans.application.titel_angaben_kind[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'child-name',
                                name: 'Name',
                                value: '',
                                label: this.trans.application.name[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'child-firstname',
                                name: 'Vorname(n)',
                                value: '',
                                label: this.trans.application.vornamen[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'child-birthday',
                                name: 'Geburtsdatum',
                                value: '',
                                label: this.trans.application.geburtsdatum[this.lang],
                                type: 'date',
                                mode: 'age',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'child-nationality',
                                name: 'Nationalität(en)',
                                value: '',
                                label: this.trans.application.nationalitaet[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                             {
                                id: 'child-ahv',
                                name: 'AHV-Nummer des Kindes',
                                value: '',
                                label: this.trans.application.ahv[this.lang],
                                type: 'text',
                                validation: [],
                                remarks: this.trans.application.info[this.lang],
                            },
                            {
                                id: 'child-siblings',
                                name: 'Geschwister',
                                value: '',
                                label: this.trans.application.geschwister[this.lang],
                                type: 'text',
                                repeats: 5,
                                validation: [],
                                placeholder: false
                            }
                        ]
                    },
                    'language':
                    {
                        title: this.trans.application.titel_kind_sprache[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'language-mother-native',
                                name: 'Muttersprache(n) Mutter',
                                value: '',
                                label: this.trans.application.muttersprache[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'language-with-mother',
                                name: 'Kind spricht mit Mutter',
                                value: '',
                               label: this.trans.application.sprechen_mutter[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                               {
                                id: 'language-father-native',
                                name: 'Muttersprache(n) Vater',
                                value: '',
                               label: this.trans.application.muttersprache_vater[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'language-with-father',
                                name: 'Kind spricht mit Vater',
                                value: '',
                                label: this.trans.application.sprechen_vater[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'language-dominant',
                                name: 'Dominante Sprache des Kindes',
                                value: '',
                                label: this.trans.application.dominante_sprache[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'language-others',
                                name: 'Weitere Sprache des Kindes mit Bezugsperson(en)',
                                value: '',
                                label: this.trans.application.weitere_sprachen[this.lang],
                                type: 'text',
                                validation: [],
                                placeholder: false
                            },
                        ]
                    },
                    'school':
                    {
                        title: this.trans.application.titel_besuchte_schule[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'school-school1',
                                name: 'Schule',
                                value: '',
                                label: this.trans.application.besuchte_schule[this.lang],
                                type: 'text',
                                validation: ['requiredIf'],
                                validationDependency: ['school-school1-fromto'],
                                class: 'nomargin',
                                placeholder: false
                            },
                            {
                                id: 'school-school1-fromto',
                                name: 'Schule von/bis',
                                value: '',
                                label: '',
                                type: 'daterange',
                                mode: 'last',
                                validation: ['requiredIf'],
                                validationDependency: ['school-school1'],
                                class: 'extramargin'
                            },
                             {
                                id: 'school-school2',
                                name: 'Schule',
                                value: '',
                                label: this.trans.application.besuchte_schule[this.lang],
                                type: 'text',
                                validation: ['requiredIf'],
                                validationDependency: ['school-school2-fromto'],
                                class: 'nomargin',
                                placeholder: false
                            },
                            {
                                id: 'school-school2-fromto',
                                name: 'Schule von/bis',
                                value: '',
                                label: '',
                                type: 'daterange',
                                mode: 'last',
                                mode: 'age',
                                validation: ['requiredIf'],
                                validationDependency: ['school-school2'],
                                class: 'extramargin'
                            },
                            {
                                id: 'school-contact',
                                titlebefore:  this.trans.application.kontaktperson[this.lang],
                                name: 'Name/Vorname',
                                value: '',
                                label: this.trans.application.lastfirst[this.lang],
                                placeholder: true,
                                type: 'text',
                                validation: ['requiredIf'],
                                validationDependency: ['school-school1'],
                                class: 'nomargin',
                                placeholder: true
                            },
                            {
                                id: 'school-phone',
                                name: 'Telefon',
                                value: '',
                                label: this.trans.application.telefon[this.lang],
                                placeholder: true,
                                type: 'text',
                                validation: ['requiredIf'],
                                validationDependency: ['school-school1'],
                                class: 'nomargin',
                                placeholder: true
                            },
                            {
                                id: 'school-email',
                                name: 'E-Mail',
                                value: '',
                                label: this.trans.application.mail[this.lang],
                                placeholder: true,
                                type: 'text',
                                validation: [],
                                validationDependency: ['school-school1'],
                                remarks: this.trans.application.absprache[this.lang],
                                class: 'nomargin',
                                placeholder: true
                            },
                         ]
                    },
                    'address':
                    {
                        title: this.trans.application.titel_adresse[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'address-separate',
                                name: 'Getrennt lebende Eltern',
                                value: '',
                                label: this.trans.application.getrennte_eltern[this.lang],
                                type: 'checkbox',
                                selection:[this.trans.application.ja[this.lang]],
                                validation: [],
                            },
                            {
                                id: 'address-street',
                                name: 'Strasse, Nr.',
                                value: '',
                                condition: ['address-separate',0],
                                label: this.trans.application.strasse[this.lang],
                                type: 'text',
                                validation: ['requiredIfNot'],
                                validationDependency: ['address-separate'],
                                placeholder: false
                            },
                            {
                                id: 'address-zip',
                                name: 'PLZ',
                                value: '',
                                condition: ['address-separate',0],
                                label: this.trans.application.plz[this.lang],
                                type: 'text',
                                validation: ['requiredIfNot'],
                                validationDependency: ['address-separate'],
                                placeholder: false
                            },
                            {
                                id: 'address-city',
                                name: 'Ort',
                                value: '',
                                condition: ['address-separate',0],
                                label: this.trans.application.ort[this.lang],
                                type: 'text',
                                 validation: ['requiredIfNot'],
                                validationDependency: ['address-separate'],
                                placeholder: false
                            },

                            {
                                id: 'address-mother-street',
                                titlebefore:  this.trans.application.mutter[this.lang],
                                name: 'Mutter: Strasse, Nr.',
                                value: '',
                                condition: ['address-separate',1],
                                label: this.trans.application.strasse[this.lang],
                                type: 'text',
                                 validation: ['requiredIf'],
                                validationDependency: ['address-separate'],
                                placeholder: false
                            },
                            {
                                id: 'address-mother-zip',
                                name: 'Mutter: PLZ',
                                value: '',
                                condition: ['address-separate',1],
                                label: this.trans.application.plz[this.lang],
                                type: 'text',
                                 validation: ['requiredIf'],
                                validationDependency: ['address-separate'],
                                placeholder: false
                            },
                            {
                                id: 'address-mother-city',
                                name: 'Mutter: Ort',
                                value: '',
                                condition: ['address-separate',1],
                                label: this.trans.application.ort[this.lang],
                                type: 'text',
                                 validation: ['requiredIf'],
                                validationDependency: ['address-separate'],
                                placeholder: false
                            },

                            {
                                id: 'address-father-street',
                                titlebefore:  this.trans.application.vater[this.lang],
                                name: 'Vater: Strasse, Nr.',
                                value: '',
                                condition: ['address-separate',1],
                                label: this.trans.application.strasse[this.lang],
                                type: 'text',
                                validation: ['requiredIf'],
                                validationDependency: ['address-separate'],
                                placeholder: false
                            },
                            {
                                id: 'address-father-zip',
                                name: 'Vater: PLZ',
                                value: '',
                                condition: ['address-separate',1],
                                label: this.trans.application.plz[this.lang],
                                type: 'text',
                                validation: ['requiredIf'],
                                validationDependency: ['address-separate'],
                                placeholder: false
                            },
                            {
                                id: 'address-father-city',
                                name: 'Vater: Ort',
                                value: '',
                                condition: ['address-separate',1],
                                label: this.trans.application.ort[this.lang],
                                type: 'text',
                                 validation: ['requiredIf'],
                                validationDependency: ['address-separate'],
                                placeholder: false
                            },


                            {
                                id: 'address-custody',
                                name: 'Sorgerecht',
                                value: '',
                                condition: ['address-separate',1],
                                label: this.trans.application.sorgerecht[this.lang],
                                type: 'radio',
                                selection: [this.trans.application.mutter[this.lang],this.trans.application.vater[this.lang],this.trans.application.gemeinsam[this.lang]],
                                validation: []
                            },

                            {
                                id: 'address-language',
                                name: this.trans.application.korrespondenzsprache[this.lang],
                                value: '',
                                label: this.trans.application.korrespondenzsprache[this.lang],
                                type: 'radio',
                                selection: [this.trans.application.deutsch[this.lang],this.trans.application.englisch[this.lang]],
                                validation: ['required'],
                            }
                        ]
                    },
                    'address-mother':
                    {
                        title: this.trans.application.titel_angaben_mutter[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                             {
                                 id: 'address-name-mother',
                                name: 'Name der Mutter',
                                value: '',
                                label: this.trans.application.name_mutter[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'address-firstname-mother',
                                name: 'Vorname der Mutter',
                                value: '',
                                label: this.trans.application.vorname_mutter[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'address-phone-mother',
                                name: 'Telefon der Mutter',
                                value: '',
                                label: this.trans.application.tel_mutter[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'address-email-mother',
                                name: 'E-Mail der Mutter',
                                value: '',
                                label: this.trans.application.mail_mutter[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                        ]
                    },
                    'address-father':
                    {
                        title: this.trans.application.titel_angaben_vater[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                             {
                                id: 'address-name-father',
                                name: 'Name des Vaters',
                                value: '',
                                label: this.trans.application.name_vater[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                             {
                                id: 'address-firstname-father',
                                name: 'Vorname des Vaters',
                                value: '',
                                label: this.trans.application.vorname_vater[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },

                            {
                                id: 'address-phone-father',
                                name: 'Telefon des Vaters',
                                value: '',
                                label: this.trans.application.tel_vater[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'address-email-father',
                                name: 'E-Mail des Vaters',
                                value: '',
                                label: this.trans.application.mail_vater[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                        ]
                    },
                    'invoice':
                    {
                        title: this.trans.application.titel_rechnungsadresse[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                             {
                                id: 'invoice-street',
                                name: 'Strasse, Nr.',
                                value: '',
                                label: this.trans.application.strasse[this.lang],
                                type: 'text',
                                validation: [],
                                placeholder: false
                            },
                            {
                                id: 'invoice-zip',
                                name: 'PLZ',
                                value: '',
                                label: this.trans.application.plz[this.lang],
                                type: 'text',
                                validation: [],
                                placeholder: false
                            },
                            {
                                id: 'invoice-city',
                                name: 'Ort',
                                value: '',
                                label: this.trans.application.ort[this.lang],
                                type: 'text',
                                validation: [],
                                placeholder: false
                            },
                            {
                                id: 'invoice-phone',
                                name: 'Telefon',
                                value: '',
                                label: this.trans.application.telefon[this.lang],
                                type: 'text',
                                validation: [],
                                placeholder: false
                            }
                        ]
                    },
                    'contact':
                    {
                        title: this.trans.application.titel_kontakte[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                             {
                                id: 'contact-name',
                                name: 'Name',
                                value: '',
                                label: this.trans.application.lastfirst[this.lang],
                                type: 'text',
                                validation: ['requiredIf'],
                                validationDependency: ['contact-phone1','contact-phone2'],
                                placeholder: false
                            },
                            {
                                id: 'contact-phone1',
                                name: 'Telefon 1',
                                value: '',
                                label: this.trans.application.te_1[this.lang],
                                type: 'text',
                                validation: ['requiredIf'],
                                validationDependency: ['contact-name'],
                                placeholder: false
                            },
                            {
                                id: 'contact-phone2',
                                name: 'Telefon 2',
                                value: '',
                                label: this.trans.application.te_2[this.lang],
                                type: 'text',
                                validation: [],
                                placeholder: false

                            },
                             {
                                id: 'contact-relation',
                                name: 'Beziehung zum Kind',
                                value: '',
                                label: this.trans.application.relation[this.lang],
                                type: 'text',
                                validation: [],
                                placeholder: false

                            }
                        ]
                    },
                    'health':
                    {
                        title: this.trans.application.titel_fragen_gesundheit[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                             {
                                id: 'health-allergies',
                                name: 'Hat Ihr Kind Allergien und / oder Asthma?',
                                value: '',
                                label: this.trans.application.frage_allergien[this.lang],
                                type: 'radio',
                                selection:[this.trans.application.ja[this.lang],this.trans.application.nein[this.lang]],
                                validation: ['required'],
                                class: ''
                            },
                             {
                                id: 'health-disability',
                                name: 'Hat Ihr Kind eine Seh- oder Hörbehinderung?',
                                value: '',
                                label: this.trans.application.frage_sehen[this.lang],
                                type: 'radio',
                                selection:[this.trans.application.ja[this.lang],this.trans.application.nein[this.lang]],
                                validation: ['required'],
                                class: ''
                            },
                             {
                                id: 'health-therapy',
                                name: 'Bekommt Ihr Kind eine Therapie?',
                                value: '',
                                label: this.trans.application.frage_therapie[this.lang],
                                type: 'radio',
                                selection:[this.trans.application.ja[this.lang],this.trans.application.nein[this.lang]],
                                validation: ['required'],
                                class: ''
                            },

                             {
                                id: 'health-other',
                                name: 'Sollte die Lakeside School  besonders auf andere medizinische Bedingungen achten? ',
                                value: '',
                                label: this.trans.application.frage_bedingungen[this.lang],
                                type: 'radio',
                                selection:[this.trans.application.ja[this.lang],this.trans.application.nein[this.lang]],
                                validation: ['required'],
                                class: ''
                            },
                            {
                                id: 'health-remarks',
                                name: 'Bemerkungen',
                                value: '',
                                label: this.trans.application.bemerkungen[this.lang],
                                type: 'textarea',
                                validation: [],
                                class: 'extramargin'
                            }
                        ]
                    },
                    'lunch':
                    {
                        title: this.trans.application.titel_fragen_hotlunch[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'lunch-diet',
                                name: 'Spezielle Diät',
                                value: '',
                                label: '<span style="display:block;padding-bottom:0.3em">'+this.trans.application.fragen_diaet[this.lang]+'</span>',
                                type: 'checkbox',
                                selection:[this.trans.application.fragen_vegan[this.lang],this.trans.application.fragen_vegi[this.lang],this.trans.application.fragen_schwein[this.lang],this.trans.application.fragen_gluten[this.lang],this.trans.application.fragen_laktose[this.lang]],
                                validation: [],
                            },

                            {
                                id: 'lunch-allergies',
                                name: 'Bekannte Nahrungsmittelallergien',
                                value: '',
                                label: this.trans.application.fragen_bekannte_allergien[this.lang],
                                type: 'textarea',
                                validation: [],
                            },
                            {
                                id: 'lunch-other',
                                name: 'Andere Diätwünsche',
                                value: '',
                                label: this.trans.application.fragen_andere_diaet[this.lang],
                                type: 'textarea',
                                validation: [],
                            },
                         ]
                    },
                    'general-policy':
                     {
                        title: "",
                        status: 0,
                        open: false,
                        haserror: false,
                        type: 'fix',
                        fields:[
                            {
                                id: 'general-policy',
                                name: 'Mit dieser Anmeldung bin ich mit den Datenschutzrichtlinien von der Lakeside School einverstanden.',
                                value: '',
                                label: this.trans.application.agree[this.lang],
                                type: 'checkbox',
                                selection:[ this.trans.application.ja[this.lang]],
                                validation: ['required']
                            },

                         ]
                    },
                    'general-conditions':
                     {
                        title: "",
                        status: 0,
                        open: false,
                        haserror: false,
                        type: 'fix',
                        fields:[
                            {
                                id: 'general-conditions',
                                name: 'Ich habe die Zahlungsbedingungen und Kündigungsfristen gelesen und bin einverstanden.',
                                value: '',
                                label: this.trans.application.agreeterms[this.lang],
                                type: 'checkbox',
                                selection:[ this.trans.application.ja[this.lang]],
                                validation: ['required']
                            }
                         ]
                    }
                }
            }
        },
        props: {

             lang: {
                type: String,
                required: true
            },
            trans: {
                type: Object,
                required: true
            },

        },


    }
</script>
